import { QrCodeScreen } from '@/components/profile/qr-code-screen';

export default function ProfileQrCodePage() {
  return <QrCodeScreen />;
}
